// initial state
const state = {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    drawer: null,
    footer: null,
    dark: false,
};

const getters = {
    barColor: state => state.barColor,
    drawer: state => state.drawer,
    footer: state => state.footer,
    dark: state => state.dark,
};
const mutations = {
    SET_DRAWER(state, drawer) {
        state.drawer = drawer;
    },
    SET_SCRIM(state, barColor) {
        state.barColor = barColor;
    },
    SET_FOOTER(state, footer) {
        state.footer = footer;
    },
    SET_DARK(state, dark) {
        state.dark = dark;
    },
};

const actions = {
    load({ commit }, config) {
        commit('SET_DRAWER', null);
        commit('SET_SCRIM', config.drawerColor);
        commit('SET_FOOTER', config.footer);
        commit('SET_DARK', config.dark);
    },

    setDrawer({ commit }, drawer) {
        commit('SET_DRAWER', drawer);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
